import React, { useEffect, useRef, useState } from 'react';
import { siteData } from '../data/mock';

const AnimatedCard = ({ children, delay = 0, style = {} }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), delay);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [delay]);

  return (
    <div
      ref={ref}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
        transition:
          'opacity 0.6s cubic-bezier(0.25,0.46,0.45,0.94), transform 0.6s cubic-bezier(0.25,0.46,0.45,0.94)',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

const WhySection = () => {
  const why = siteData.whySection;

  return (
    <section className="relative w-full" style={{ background: '#fff' }}>
      {/* "why we built demoboy?" + 3 cards */}
      <div
        className="section-pad why-layout"
        style={{
          alignItems: 'stretch',
        }}
      >
        {/* Left: heading + description */}
        <AnimatedCard delay={0} style={{ flex: '0 0 280px', display: 'flex' }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <h2
              style={{
                fontFamily: 'Coolvetica, sans-serif',
                fontSize: 'clamp(32px, 6.2vw, 48px)',
                fontWeight: 400,
                color: '#000',
                letterSpacing: '-0.025em',
                lineHeight: 'clamp(34px, 6.4vw, 50px)',
              }}
            >
              why we built{'\n'}demoboy
              <span style={{ color: '#FF98BF' }}> ?</span>
            </h2>
            <p
              style={{
                fontFamily: 'InterVariable, sans-serif',
                fontSize: '16px',
                fontWeight: 400,
                fontStyle: 'italic',
                color: '#000',
                lineHeight: '20px',
                marginTop: '20px',
              }}
            >
              {why.description}
            </p>
          </div>
        </AnimatedCard>

        {/* Right: 3 equal-height numbered cards */}
        <div className="why-cards">
          {why.cards.map((card, i) => (
            <AnimatedCard key={i} delay={150 * (i + 1)} style={{ flex: 1, display: 'flex' }}>
              <div
                className="why-card-macos"
                style={{
                  flex: 1,
                  border: '1px solid #c0c5ce',
                  borderRadius: '12px',
                  padding: 'clamp(18px, 4vw, 24px) clamp(18px, 4vw, 24px) clamp(22px, 4.6vw, 28px)',
                  background: '#fff',
                  cursor: 'default',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <span
                  style={{
                    fontFamily: 'InterVariable, sans-serif',
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#999',
                    display: 'block',
                    marginBottom: '12px',
                  }}
                >
                  {card.number}
                </span>
                <h3
                  style={{
                    fontFamily: 'Coolvetica, sans-serif',
                    fontSize: '32px',
                    fontWeight: 400,
                    color: '#000',
                    letterSpacing: '-0.025em',
                    lineHeight: '34px',
                    whiteSpace: 'pre-line',
                    marginBottom: '16px',
                  }}
                >
                  {card.title}
                </h3>
                <p
                  style={{
                    fontFamily: 'InterVariable, sans-serif',
                    fontSize: '15px',
                    fontWeight: 400,
                    fontStyle: 'italic',
                    color: '#000',
                    lineHeight: '20px',
                    marginTop: 'auto',
                  }}
                >
                  {card.body}
                </p>
              </div>
            </AnimatedCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySection;
